import React, { useState, useRef } from 'react'
import { Row, Col, Form, FormGroup, InputGroup, FormControl, ButtonGroup, Button, ToggleButton } from 'react-bootstrap'
import apiHelper from '../../util/api.helper.js';

import NPHelpButton from '../../NPHelpButton';
import NPReactTable from '../../NPReactTable';
import { export2Excel, filterMultiple, filterNumber, getFilteredData, setDataForExpansion, getSum, getExpander, getLabelColumn } from '../../gridHelpers/gridHelpers';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilePdf, faFileWord, faFileExcel, faFilePowerpoint, faFileImage, faFile, faEye } from '@fortawesome/free-regular-svg-icons'
import NPLightbox from '../../NPLightbox/index'

//import './style.scss'

class DocumentsPresentation extends React.Component {
    constructor(props) {
        super(props)

        this.getClearedState = this.getClearedState.bind(this)
        this.getColumns = this.getColumns.bind(this)

        this.downloadAttachment = this.downloadAttachment.bind(this)

        this.state = this.getClearedState();
        this.getFileSymbol = this.getFileSymbol.bind(this);

        this.getFileExtension = this.getFileExtension.bind(this);
        this.closeLightbox = this.closeLightbox.bind(this);
        this.previewImage = this.previewImage.bind(this);

        this.state = {
            showLightbox: false,
            currentImage: null,
            header: this.props.header,
            imageEndpoint: 'files/getImage'
        }
    }

    previewImage(row) {
        this.setState({
            currentImage: row,
            showLightbox: true
        });
    }

    closeLightbox() {
        this.setState({showLightbox: false})
    }

    

    getClearedState() {
        return ({
            sorted: [],
            page: 0,
            pageSize: 10,
            resized: [],
            filtered: [],
            showModal: false,
            loaded: false,
        });
    }

    getFileExtension(fileName){
        if(fileName.includes('.'))
        {
            return fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length)
        }
        return "";
    }

    getFileSymbol(fileName)
    {
        let extension = this.getFileExtension(fileName);

        switch(extension)
        {
            case 'pdf':
                return <FontAwesomeIcon icon={faFilePdf} size="2x" color="#d33"/>;
            case 'doc':
            case 'docx':
                return <FontAwesomeIcon icon={faFileWord} size="2x" color="#143C89"/>;
            case 'xlsx':
                return <FontAwesomeIcon icon={faFileExcel} size="2x" color="#1D7348"/>;      
            case 'ppt':
            case 'pptx':
                return <FontAwesomeIcon icon={faFilePowerpoint} size="2x" color="#CD4F2E"/>;
            case 'jpg':
            case 'jpeg':
                return <FontAwesomeIcon icon={faFileImage} size="2x" color="#00529C"/>;
        }

        return <FontAwesomeIcon icon={faFile} size={"2x"} color="#00529C"/>;
    }

    downloadAttachment(cell) {
        console.log("downloading..", cell)
    }

    getColumns(imageFetch) {
        let self = this;
        const helpNode = (
            <div>
                <h3>Filters</h3>

                <p>There are fields at the top of the table that can be used for filtering</p>

                <p>
                    If a text box for a column is empty, no filtering for that column will be done.<br />
                    If the data is left-aligned and the text box is not empty, the filter will remove rows that do not contain the text in the text box<br />
                    It is possible to use multiple filters for text based values by writing a comma, for example "Ordered, Being produced"<br /><br />
                    Examples follows for right-aligned (numbers):<br />
                    Empty text box, no filtering.<br />
                    <strong>&lt; 10</strong> view rows with data that is less than 10<br />
                    <strong>&gt; 10</strong> view rows with data that is more than 10<br />
                    <strong>20-30</strong> view rows with data that is between 20 and 30.
                </p>
            </div>
        )

        return ([
            {
                Header: "",
                maxWidth: 30,
                Filter: ({ filter, onChange }) =>
                    <NPHelpButton content={helpNode} title="Help" />
            },
            
            {
                Header: "Documents",
                headerStyle: { background: '#DDDDDD' },
                columns: [
                    {
                        accessor: "TitleWithType",
                        maxWidth: 40,
                        Cell: file => (
                            <div style={{margin: "auto", textAlign: "center"}}>
                                {self.getFileSymbol(file.row.Title)}
                            </div>
                        ),
                        filterable: false
                    },
                    {
                        Header: "Title",
                        accessor: "Title",
                        filterable:true
                    },
                    {
                        Header: "Category",
                        accessor: "Category.Title",
                    },
                    {
                        Header: "Size",
                        accessor: "Size",
                        maxWidth: 140,
                    },
                    {
                        Header: "Last modified",
                        accessor: "Date",
                        maxWidth: 140,
                    },
                    {
                        show: imageFetch,
                        maxWidth: 40,
                        Cell: file => (
                            <FontAwesomeIcon icon={faEye} size={"2x"} color="#00529C" onClick={() => {self.previewImage(file.row)}}/>
                        ),
                        filterable:false
                    },
                    {
                        Header: "Download",
                        accessor: "Id",
                        maxWidth: 120,
                        Cell: file => (
                            <button value={file.row.Title} onClick={() => { apiHelper.getFile(this.props.header, 'Files/GetDocument', file.original, file.original.Title); } }>
                                Download
                            </button>
                        ),
                        filterable:false
                    }
                ]
            }
        ]);
    }

    render() {
        const { pageData } = this.props;
        let imageFetch = pageData.some(x => this.getFileExtension(x.Title) === 'jpg' || this.getFileExtension(x.Title) === 'jpeg');
        pageData.map(element =>  ({...element, TitleWithType: element.Title}))
        let showLightbox = this.state.showLightbox;
        return (
            <div>
                <Row>
                        <Col sm={12} md={12}>
                            <NPReactTable
                                className="np-react-table"
                                data={pageData}
                                ref={(r) => { this.reactTable = r }}
                                columns={this.getColumns(imageFetch)}
                                defaultFilterMethod={filterMultiple}
                                filterable
                                filterAll
                                defaultPageSize={10}
                                // Controlled props
                                sorted={this.state.sorted}
                                page={this.state.page}
                                pageSize={this.state.pageSize}
                                resized={this.state.resized}
                                filtered={this.state.filtered}
                                // Callbacks
                                onSortedChange={sorted => this.setState({ sorted })}
                                onPageChange={
                                    page => {
                                        this.setState({ page });
                                }}
                                onPageSizeChange={(pageSize, page) => {
                                    this.setState({ page, pageSize });
                                }}
                                onResizedChange={resized => this.setState({ resized })}
                                onFilteredChange={filtered => {
                                    this.setState({ filtered, page: 0 })
                                }}
                            />
                        </Col>
                    </Row>
                    {showLightbox && <NPLightbox onClose={this.closeLightbox} image={this.state.currentImage} header={this.state.header} endpoint={this.state.imageEndpoint} />   }
            </div>

        )
    }
}

export default DocumentsPresentation;
